
  import { Options, Vue } from 'vue-class-component';
  import { ref } from 'vue';

  import CustomerNavigation from '@/views/userportal/navigation/CustomerNavigation.vue';
  import HomeView from '@/views/userportal/subviews/HomeView.vue';
  import ModuleManagement from '@/views/userportal/subviews/ModuleManagement.vue';
  import RequestTutorView from '@/views/userportal/subviews/RequestTutorView.vue';
  import TutorialSessionAdmin from '@/views/userportal/subviews/TutorialSessionAdmin.vue';
  

  @Options({
      components: {
        CustomerNavigation,
        HomeView,
        ModuleManagement,
        RequestTutorView,
        TutorialSessionAdmin,
      },
      provide: 
      {
        currentTheme : ref('dark')
      }   
  })
  export default class CustomerPortal extends Vue {

    theme : any = ref('dark');
    activePage = 'home-view';   

    toggleTheme() : void {
        this.theme = this.theme === 'light' ? 'dark' : 'light';
    }

    setActivePage(page: string) { 
      // set active page to the selected one on the nav bar
      this.activePage = page; 
    }
  }
